

//*************************DO NOT MODIFY**************************
//
//THESE FILES ARE AUTOGENERATED WITH TYPEWRITER AND ANY MODIFICATIONS MADE HERE WILL BE LOST
//PLEASE VISIT http://frhagn.github.io/Typewriter/ TO LEARN MORE ABOUT THIS VISUAL STUDIO EXTENSION
//
//*************************DO NOT MODIFY**************************
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { FormationContinueForListViewModel } from '../models/FormationContinueForListViewModel';
import { SessionFormationTotalStatutModel } from '../models/SessionFormationTotalStatutModel';
import { FormationContinueEditModel } from '../models/FormationContinueEditModel';
import { FormationContinuePlatModel } from '../models/FormationContinuePlatModel';
import { CategorieHierarchiqueModel } from '../models/CategorieHierarchiqueModel';
import { StatutEmploiModel } from '../models/StatutEmploiModel';
import { IdNomModel } from '../models/IdNomModel';

@Injectable({
   providedIn: 'root'
})
export class FormationContinueApiService {
    constructor(private _httpClient: HttpClient) { }        
    
    // get: api/FormationContinue/getListFormationContinue?first=${first}&rows=${rows}&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}&total=${total}&annee=${annee}&siteId=${siteId}&globalFilter=${encodeURIComponent(globalFilter)}&isStatutValide=${isStatutValide}
    getListFormationContinue(first: number, rows: number, sortField: string, sortOrder: number, total: number, annee: number, siteId: number, globalFilter: string, isStatutValide: number): Observable<FormationContinueForListViewModel> {
        var _Url = `api/FormationContinue/getListFormationContinue?first=${first}&rows=${rows}&sortField=${encodeURIComponent(sortField)}&sortOrder=${sortOrder}&total=${total}&annee=${annee}&siteId=${siteId}&globalFilter=${encodeURIComponent(globalFilter)}&isStatutValide=${isStatutValide}`;
            return this._httpClient.get<FormationContinueForListViewModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getSessionFormationTotalByStatut?annee=${annee}&siteId=${siteId}
    getSessionFormationTotalByStatut(annee: number, siteId: number): Observable<SessionFormationTotalStatutModel> {
        var _Url = `api/FormationContinue/getSessionFormationTotalByStatut?annee=${annee}&siteId=${siteId}`;
            return this._httpClient.get<SessionFormationTotalStatutModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getFormationContinue?formationId=${formationId}
    getFormationContinue(formationId: number): Observable<FormationContinueEditModel> {
        var _Url = `api/FormationContinue/getFormationContinue?formationId=${formationId}`;
            return this._httpClient.get<FormationContinueEditModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getNewSessionFormation?etablissementId=${etablissementId}
    getNewSessionFormation(etablissementId: number): Observable<FormationContinueEditModel> {
        var _Url = `api/FormationContinue/getNewSessionFormation?etablissementId=${etablissementId}`;
            return this._httpClient.get<FormationContinueEditModel>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getFormationContinuesPlat?siteId=${siteId}&annee=${annee}
    getFormationContinuesPlat(siteId: number, annee: number): Observable<FormationContinuePlatModel[]> {
        var _Url = `api/FormationContinue/getFormationContinuesPlat?siteId=${siteId}&annee=${annee}`;
            return this._httpClient.get<FormationContinuePlatModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // post: api/FormationContinue/save
    save(formation: FormationContinueEditModel): Observable<FormationContinueEditModel> {
        var _Url = `api/FormationContinue/save`;
            return this._httpClient.post<FormationContinueEditModel>(_Url, formation).pipe(catchError(this.handleError));
    }
    
    // post: api/FormationContinue/delete?id=${id}
    delete(id: number): Observable<boolean> {
        var _Url = `api/FormationContinue/delete?id=${id}`;
            return this._httpClient.post<boolean>(_Url, id).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getAnneesAvecFormation
    getAnneesAvecFormation(): Observable<number[]> {
        var _Url = `api/FormationContinue/getAnneesAvecFormation`;
            return this._httpClient.get<number[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getAnneesForNewFormation
    getAnneesForNewFormation(): Observable<number[]> {
        var _Url = `api/FormationContinue/getAnneesForNewFormation`;
            return this._httpClient.get<number[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getCategorieHierarchiques
    getCategorieHierarchiques(): Observable<CategorieHierarchiqueModel[]> {
        var _Url = `api/FormationContinue/getCategorieHierarchiques`;
            return this._httpClient.get<CategorieHierarchiqueModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getStatutEmplois
    getStatutEmplois(): Observable<StatutEmploiModel[]> {
        var _Url = `api/FormationContinue/getStatutEmplois`;
            return this._httpClient.get<StatutEmploiModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // get: api/FormationContinue/getTypeActions
    getTypeActions(): Observable<IdNomModel[]> {
        var _Url = `api/FormationContinue/getTypeActions`;
            return this._httpClient.get<IdNomModel[]>(_Url).pipe(catchError(this.handleError));
    }
    
    // Utility
    private handleError(error: HttpErrorResponse) {
        console.error(error);
        let customError: string = "";
        if (error.error) {
            customError = error.status === 400 ? error.error : error.statusText
        }
        return throwError(customError || 'Server error');
    }
}
